import {useEffect,useMemo,useSyncExternalStore} from 'react';
import {CircleDot} from 'lucide-react';
import {Icon} from '../../ui/Icon.tsx';
import {useWorkspace} from '../../state/workspace.tsx';
import {CallRecordingControl,canManageCallRecording,type CallRecordingState} from './callRecording.ts';

export function CallRecordingSwitchView({state,onToggle,onReload}:{state:CallRecordingState;onToggle:()=>void;onReload:()=>void}){
 const enabled=state.value?.enabled===true;
 const label=state.phase==='saving'?'Saving':state.phase==='loading'?'Loading':state.value?(enabled?'On':'Off'):'Unavailable';
 const tone=state.value?(enabled?'live':'neutral'):'warn';
 return <div className="coach-switch" data-slot="call-recording">
  <button type="button" role="switch" aria-label="Call recording" aria-checked={enabled} disabled={state.phase!=='ready'}
   className="coach-switch-btn" aria-describedby="call-recording-detail" onClick={onToggle}>
   <Icon icon={CircleDot} /> Call recording
   <span className={`chip chip-lamp tone-${tone}`}><span className={`dot dot-${tone}`} aria-hidden="true" />{label}</span>
  </button>
  <p className="field-hint" id="call-recording-detail">Default audio recording for future calls. Admin / People can override each user. Current calls and transcription stay unchanged.</p>
  {state.message?<p className="field-hint" role={state.phase==='error'?'alert':'status'}>{state.message}</p>:null}
  {state.reauthenticate?<a className="btn" href="/api/v1/auth/google/start?reauth=1&return_to=%2Fphone">Sign in again</a>
   :state.phase==='error'?<button className="btn" type="button" onClick={onReload}>Try again</button>:null}
 </div>;
}
function AdminCallRecordingSwitch(){
 const ws=useWorkspace();
 const control=useMemo(()=>new CallRecordingControl(ws.api),[ws.api,ws.userId,ws.session.tenant?.id]);
 const state=useSyncExternalStore(control.subscribe,control.snapshot,control.snapshot);
 useEffect(()=>{
  void control.load();
  const refresh=()=>{void control.load();};
  window.addEventListener('focus',refresh);
  return()=>{window.removeEventListener('focus',refresh);control.cancel();};
 },[control]);
 return <CallRecordingSwitchView state={state} onToggle={()=>{void control.toggle();}} onReload={()=>{void control.load();}} />;
}
/** The inner control never mounts or fetches the setting for ordinary staff or view-as sessions. */
export function CallRecordingSwitch(){
 const ws=useWorkspace();
 return canManageCallRecording(ws.session)?<AdminCallRecordingSwitch key={`${ws.session.tenant?.id}:${ws.userId}`} />:null;
}
